import { render, staticRenderFns } from "./StudentSubmissionModal.vue?vue&type=template&id=3aa003f4&scoped=true"
import script from "./StudentSubmissionModal.vue?vue&type=script&lang=js"
export * from "./StudentSubmissionModal.vue?vue&type=script&lang=js"
import style0 from "./StudentSubmissionModal.vue?vue&type=style&index=0&id=3aa003f4&prod&lang=stylus&scoped=true"
import style1 from "./StudentSubmissionModal.vue?vue&type=style&index=1&id=3aa003f4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa003f4",
  null
  
)

export default component.exports